import styled from 'styled-components';
import { colorNameToHex } from '../../stylings';

export const StoreStatusContainer = styled.div<{ $isOpen: boolean }>`
  color: ${({ $isOpen }) => ($isOpen ? colorNameToHex.green : colorNameToHex.red)};
`;
